import React from "react";
import "../scss/Elements/_tables.scss"

function Items() {
  return (
      <div></div>
    );
  }

export default Items;